<template>
    <el-drawer
        title="发放优惠券"
        :visible.sync="visible"
        :wrapperClosable="false"
        :size="450"
        @closed="closed"
    >
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" >
                <el-form-item label="发放优惠券:">
                    <span>{{name}}</span>
                </el-form-item>
                <el-form-item prop="type" label="发放方式:">
                    <el-radio v-model="formData.type" :label="1">通过用户ID发放</el-radio>
                    <el-radio v-model="formData.type" :label="2">通过手机号发放</el-radio>
                </el-form-item>
                <el-form-item prop="content" label="输入ID或手机号:">
                    <el-input type="textarea" v-model="formData.content" placeholder="请填写" size="medium" :maxlength="100000"></el-input>
                    <small class="from-tip"><span class="el-icon-warning"></span>选择【通过用户ID发放】则只能填写ID</small>
                    <small class="from-tip"><span class="el-icon-warning"></span>选择【通过手机号发放】则只能填写大陆11位手机号</small>
                    <small class="from-tip"><span class="el-icon-warning"></span>多个ID或者手机号之间用逗号分隔</small>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="submitLoading">提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
export default {
    data() {
        this.defaultFormData = {
            id: null,
            // 发放方式：必填，单选，默认选中【通过用户ID发放】
            type: 1,
            // 输入ID或手机号 必填，最多10W个字符，仅允许填写数字或逗号，
            // 如果格式有误，提示：【请填写有效的ID或者手机号】，
            // 如果为空，提示：【请填写用户ID或者手机号】，如果超长，提示：【最多允许填写10W个字符】
            content: null
        }

        // 验证使用范围
        const validateContent = (rule, value, callback) => {
            if (value && !/^[,，0-9]+$/.test(value)) {
                callback(new Error('请填写有效的ID或者手机号'));
            } else {
                callback();
            }
        };
        
        return {
            visible: false,
            formData: {
                ...this.defaultFormData
            },
            name: null,
            rules: {
                type: { required: true, message: "请选择发放方式", trigger: 'change'},
                content: [
                    { required: true, message: "请填写ID或手机号", trigger: 'change'},
                    { validator: validateContent, trigger: 'change'}
                ]
            },
            submitLoading: false
        };
    },
    methods: {
        show(data) {
            const {id, name} = data || {};
            this.formData = {id, type: 1, content: null};
            this.name = name;
            this.visible = true;
        },
        closed() {
            this.formData = {...this.defaultFormData};
            
            this.$nextTick(() => {
                this.$refs['formData'].clearValidate();
            });
        },
        // 表单提交
        submitForm() {
            this.$refs["formData"].validate(async (valid) => {
                if(!valid) {
                    return ;
                }

                const {formData: {content, ...otherData}} = this;

                this.submitLoading = true;

                const res = await this.$request({
                    url: '/coupon/goods/send',
                    method: 'post',
                    data: {...otherData, content: content.replace(/，/g, ',')}
                }).catch(() => {
                    return {data: {state: '0', msg: '请求错误'}};
                }).finally(() => {
                    this.submitLoading = false;
                });

                const { state, msg } = res.data;

                if(state !== '1') {
                    this.$message.error(msg || '请求失败');
                    return ;
                }

                this.$emit('submitSuccess');
                this.visible = false;
            });
        }
    }
};
</script>